import React, { useEffect, useState } from 'react';
import Header from '../../components/ui/Header';
import Footer from '../homepage/components/Footer';
import Icon from '../../components/AppIcon';
import circlesService from '../../services/circlesService';

const CirclesPage = () => {
  const [circlesData, setCirclesData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchCircles = async () => {
      try {
        const { data } = await circlesService.getCircles();
        const all = data || [];
        const rootCircles = all.filter((c) => !c.parentId);
        const mapped = rootCircles.map((c) => {
          const children = all.filter((ch) => ch.parentId === c.id);
          return {
            id: c.slug,
            name: c.name,
            icon: c.icon || 'Circle',
            description: c.subtext || '',
            hasSubSection: children.length > 0,
            subSection: children.length > 0 ? {
              title: c.name,
              icon: c.icon || 'Feather',
              types: children.map((ch) => ({ type: ch.name, quote: ch.subtext || '' })),
            } : null,
          };
        });
        setCirclesData(mapped);
      } catch (err) {
        console.error('Failed to fetch circles:', err);
        setCirclesData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCircles();
  }, []);


  return (
    <div className="min-h-screen bg-[#F9F7F2]">
      <Header />
      
      <main className="pt-32 pb-24 px-4 md:px-8 max-w-7xl mx-auto">
        {/* Page Title */}
        <div className="text-center mb-24">
          <h1 className="text-4xl md:text-5xl font-bold text-[#C5A059] font-['Aref_Ruqaa'] mt-14 mb-[22px] pt-8">
            الدوائر العشر
          </h1>
          <div className="w-24 h-1 bg-[#C5A059]/30 mx-auto rounded-full"></div>
        </div>

        {/* Circles List */}
        <div className="flex flex-col gap-24">
          {loading ? (
            <div className="flex justify-center py-16">
              <div className="w-8 h-8 border-2 border-[#C5A059] border-t-transparent rounded-full animate-spin" />
            </div>
          ) : (
          circlesData?.map((circle, index) =>
          <div
            key={circle?.id}
            className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-8 lg:gap-16`}>

              {/* Icon Circle */}
              <div className="relative group">
                <div className="w-32 h-32 md:w-40 md:h-40 rounded-full border border-[#C5A059] flex items-center justify-center bg-[#F9F7F2] relative z-10 transition-transform duration-500 hover:scale-105">
                  {circle?.id === 'sufism' ?
                <img
                  src="/assets/images/Screenshot_2026-01-22_223436-removebg-preview-1769116472162.png"
                  alt="Sufism"
                  className="w-12 h-12 object-contain opacity-80" /> :

                circle?.id === 'soul' ?
                <img
                  src="/assets/images/Screenshot_2026-01-22_223930-removebg-preview_1_-1769115911481.png"
                  alt="Soul"
                  className="w-16 h-16 object-contain opacity-90" /> :


                <Icon name={circle?.icon} size={48} color="#2c2c2c" className="opacity-90" />
                }
                </div>
                {/* Decorative Blur behind */}
                <div className="absolute inset-0 bg-[#C5A059]/10 rounded-full blur-xl -z-10 scale-90 group-hover:scale-110 transition-all duration-700"></div>
              </div>

              {/* Text Content */}
              <div className={`flex-1 text-center ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                <h2 className="text-3xl font-bold text-[#2c2c2c] font-['Aref_Ruqaa'] mb-4">
                  {circle?.name}
                </h2>
                <div className="text-lg md:text-xl text-[#5A5A5A] font-['Amiri'] leading-loose whitespace-pre-line">
                  {circle?.description}
                </div>

                {/* Nested Poetry Section - Integrated Branch Layout */}
                {circle?.hasSubSection &&
              <div className="mt-8 pr-6 border-r-2 border-[#C5A059]/30 mr-2">
                    {/* Sub-Header */}
                    <div className="flex items-center gap-3 mb-4">
                      <Icon name="Feather" size={20} color="#C5A059" /> {/* Gold Icon as Anchor */}
                      <h3 className="text-xl font-bold font-['Aref_Ruqaa'] text-[#2c2c2c]">
                        {circle?.subSection?.title}
                      </h3>
                    </div>

                    {/* Clean List */}
                    <div className="space-y-4">
                      {circle?.subSection?.types?.map((type, idx) =>
                  <div key={idx} className="flex flex-col gap-1">
                          <span className="font-bold text-[#2c2c2c] text-base">
                            {type?.type}
                          </span>
                          <span className="text-[#5A5A5A] text-sm italic font-light opacity-80">
                            "{type?.quote}"
                          </span>
                        </div>
                  )}
                    </div>
                  </div>
              }
              </div>
            </div>
          ))}
        </div>
      </main>

      <Footer />
    </div>);

};

export default CirclesPage;